import React from "react";
import "./AllProductPage.css";
import AllProducts from "../../Components/AllProducts/AllProducts";
import product_banner from '../../assets/images/desktopImage_4_banner.jpg'
import product_banner_mobile from '../../assets/images/mobileImage_4.jpg'
import CommonBanner from "../../common/CommonBanner/CommonBanner";
import SEO from "../../common/SEO/SEO";

const allProductsSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Shop All Contemporary Apparel & Streetwear",
  "description": "Browse the entire catalogue of Maya Wears apparel. Premium oversized t-shirts, statement outerwear, knitwear, and bottoms crafted in Nepal.",
  "url": "https://mayawears.com.np/all_product",
  "isPartOf": {
    "@type": "WebSite",
    "name": "Maya Wears",
    "url": "https://mayawears.com.np"
  }
};

const AllProductPage = () => {
  return (
    <div>
      <SEO
        title="Shop All Apparel & Contemporary Streetwear"
        description="Browse all Maya Wears collections. Oversized tees, tailored trousers, outerwear, and modern streetwear designed and crafted in Nepal. Fast nationwide delivery."
        canonical="https://mayawears.com.np/all_product"
        keywords="shop clothes Nepal, Maya Wears apparel, buy streetwear online Nepal, oversized t-shirts Kathmandu, men and women streetwear Nepal"
        schema={allProductsSchema}
      />
      <CommonBanner product_banner={product_banner} product_banner_mobile={product_banner_mobile} title="Discover Quality, Style, and Value" subtitle="All in One Place!" />      
      <AllProducts />
    </div>
  );
};

export default AllProductPage;
